module.exports = "/_next/static/images/885e817f7d98503238dda0fc3c101043-mb-hero-xs-experiment.jpg";